// extracted by mini-css-extract-plugin
module.exports = {"ReviewLogo":"ReviewLogo_ReviewLogo__3aq3h"};